import Nav from "./Components/NavComponent/Nav";
import Service from "./Components/Service";
import ChatBox from "./Components/Chat/ChatBox";
import AboutUs from "./Components/About Us/About";
import Contact from "./Components/Contact";
import Blog from "./Components/Blog";
import BlogArticle from "./Components/BlogArticle";
import './App.css';
import Home from "./Components/Home";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import AccountSettings from "./Components/NavComponent/AccountSettings";
import Footer from "./Components/Footer"
import FloatingContact from "./Components/FloatingContact";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollContainer = document.getElementById("scroll-container");
    if (scrollContainer) {
      // Use setTimeout to ensure DOM is fully updated
      setTimeout(() => {
        scrollContainer.scrollTop = 0;
        // Also scroll window as fallback
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-body">
        <div className="fixed top-0 left-0 right-0 z-50">
          <Nav />
        </div>

        <div
          className="custom-scrollbar flex-1 overflow-y-auto bg-body pt-[88px] md:pb-10 "
          id="scroll-container"
        >
          <div>
          <Routes>
            <Route path="/" element={
              <div>
                <Home />
                <AboutUs />
                <Contact />
              </div>
            } />

            <Route path="/services" element={<Service />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/account-settings" element={<AccountSettings />} />
          </Routes>
        </div>
        </div>

        {/* <div className="fixed bottom-0 left-0 right-0 z-50">
          <Footer />
        </div> */}

        <Footer/>
        <FloatingContact />
        <ChatBox />
      </div>
    </BrowserRouter>
  );
}

export default App;
